import { render } from "./land_agreement.vue?vue&type=template&id=6acf4416"
import script from "./land_agreement.vue?vue&type=script&lang=js"
export * from "./land_agreement.vue?vue&type=script&lang=js"

import "./land_agreement.vue?vue&type=style&index=0&id=6acf4416&lang=scss"
script.render = render

export default script